import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

const IsGranted = ({ permissions: permissionsProps, children }) => {
  const userStatus = useSelector((state) => state.securityNew.userStatus);

  const permissions = useMemo(
    () => (Array.isArray(permissionsProps) ? permissionsProps : [permissionsProps]),
    [permissionsProps],
  );

  const result = useMemo(() => permissions.some((element) => userStatus.includes(element)), [permissions, userStatus]);

  return result ? children : null;
};

export default memo(IsGranted);
